import { trigger, transition, style, state, query, animateChild, animate, group, keyframes } from '@angular/animations';

export const fadeAnimation = trigger('routeAnimations', [
  transition('* => *', [
    query(':enter', [style({ opacity: 0 })], { optional: true }),

    query(':leave', [style({ opacity: 1 }), animate('0.5s', style({ opacity: 0 }))], {
      optional: true
    }),

    query(':enter', [style({ opacity: 0 }), animate('0.5s', style({ opacity: 1 }))], {
      optional: true
    })
  ])
]);
/*
export const fadeInAnimation =
  trigger('routeAnimations', [
    transition('* <=> *', [
      style({ position: 'relative' }),
      query(':enter, :leave', [
        style({
          position: 'absolute',
          top: 0,
          left: 0,
          zIndex: 1,
          width: '100%'
        })
      ], { optional: true }),
      query(':enter', [
        style({ left: '-100%'})
      ], { optional: true }),
      query(':leave', animateChild(), { optional: true }),
      group([
        query(':leave', [
          animate('500ms ease-out', style({ left: '100%'}))
        ], { optional: true }),
        query(':enter', [
          animate('500ms ease-out', style({ left: '0%'}))
        ], { optional: true })
      ]),
      query(':enter', animateChild(), { optional: true }),
    ])
  ]);
*/
